import { useTheme, type Theme } from '@/lib/theme'
import { cn } from '@/lib/cn'

const OPTIONS: { value: Theme; label: string; icon: string }[] = [
  { value: 'light', label: 'Light', icon: '☀' },
  { value: 'system', label: 'System', icon: '◐' },
  { value: 'dark', label: 'Dark', icon: '☾' },
]

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <div
      role="radiogroup"
      aria-label="Colour theme"
      className="flex items-center gap-0.5 rounded-full border border-line bg-ink-900/60 p-0.5"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={theme === option.value}
          aria-label={option.label}
          title={option.label}
          onClick={() => setTheme(option.value)}
          className={cn(
            'pressable grid size-7 place-items-center rounded-full text-[13px]',
            theme === option.value
              ? 'bg-ink-750 text-ink-100 shadow-sm'
              : 'text-ink-500 hover:text-ink-300',
          )}
        >
          <span aria-hidden>{option.icon}</span>
        </button>
      ))}
    </div>
  )
}
